import { CanAccess } from 'react-admin';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { type ComponentType, lazy } from 'react';

import { resources } from '@repo/c360-ra-components';

const AsyncPageList = lazy(() => import('./list'));
const AsyncPageShow = lazy(() => import('./show'));

const protectedList = () => (
  <CanAccess resource={resources.facRecords} action="list">
    <AsyncPageList />
  </CanAccess>
);

const protectedShow = () => (
  <CanAccess resource={resources.facRecords} action="show">
    <AsyncPageShow />
  </CanAccess>
);

export default {
  list: protectedList as ComponentType<any>,
  show: protectedShow as ComponentType<any>,
  icon: ReceiptLongIcon,
};
